import {
  UPDATE_RESOURCES,
  UPDATE_ELEMENT,
  UPDATE_APPS,
  RESET_ELEMENT,
  CREATE_TEMPLATE,
  DELETE_TEMPLATE,
  CREATE_PATTERN,
  DELETE_PATTERN,
  CREATE_ELEMENT,
  DELETE_ELEMENT,
  RESET_RESOURCES,
  UPDATE_PARTNERS
} from 'store/actions/cms';

export default {
  [UPDATE_RESOURCES]: (state, { resources, partnerId }) => {
    state.resources = {
      ...state.resources,
      [partnerId]: resources
    };
  },
  [UPDATE_ELEMENT]: (state, element) => {
    state.element = element;
  },
  [UPDATE_APPS]: (state, apps) => {
    state.apps = apps;
  },
  [RESET_ELEMENT]: state => {
    state.element = {};
  },
  [CREATE_TEMPLATE]: (state, data) => {
    state.resources[data.partnerId].push(data.body);
  },
  [DELETE_TEMPLATE]: (state, data) => {
    state.resources[data.partnerId] = state.resources[data.partnerId].filter(
      resource => resource.name !== data.templateName
    );
  },
  [CREATE_PATTERN]: (state, data) => {
    state.resources[data.partnerId] = state.resources[data.partnerId].map(resource => {
      if (resource.name === data.templateName) {
        resource.patterns.push(data.body);
      }
      return resource;
    });
  },
  [DELETE_PATTERN]: (state, data) => {
    state.resources[data.partnerId] = state.resources[data.partnerId].map(resource => {
      if (resource.name === data.templateName) {
        return {
          ...resource,
          patterns: resource.patterns.filter(pattern => pattern.id !== data.patternName)
        };
      }
      return resource;
    });
  },
  [CREATE_ELEMENT]: (state, data) => {
    state.resources[data.partnerId] = state.resources[data.partnerId].map(resource => {
      if (resource.name === data.templateName) {
        // eslint-disable-next-line no-param-reassign
        resource.patterns = resource.patterns.map(pattern => {
          if (pattern.id === data.patternName) {
            pattern.elements.push(data.body);
          }
          return pattern;
        });
      }
      return resource;
    });
  },
  [DELETE_ELEMENT]: (state, data) => {
    state.resources[data.partnerId] = state.resources[data.partnerId].map(resource => {
      if (resource.name === data.templateName) {
        // eslint-disable-next-line no-param-reassign
        resource.patterns = resource.patterns.map(pattern => {
          if (pattern.id === data.patternName) {
            return {
              ...pattern,
              elements: pattern.elements.filter(element => element.id !== data.elementName)
            };
          }
          return pattern;
        });
      }
      return resource;
    });
  },

  [RESET_RESOURCES]: state => {
    state.resources = {};
  },

  [UPDATE_PARTNERS]: (state, data) => {
    state.partners = data;
  }
};
